interface LogoProps extends React.ComponentProps<"img"> {
  variant?: "A" | "B" | "C" | "It";
  tone?: "default" | "light";
}

export const Logo = ({
  variant = "A",
  tone = "default",
  ...props
}: LogoProps) => {
  return (
    <img
      src={
        tone === "light" && variant !== "It"
          ? "/logo-full-light.png"
          : `/logo-variant-${variant.toLowerCase()}.png`
      }
      alt="Rentinit"
      {...props}
    />
  );
};
